module.exports = __webpack_public_path__ + "img/1520125042.0a30f2de.jpg";